const PERM: Uint8Array = new Uint8Array(512);
const GRAD: Float32Array = new Float32Array(512);

export function perlinSeed(seed: number): void {
  const p = new Uint8Array(256);
  for (let i = 0; i < 256; i++) p[i] = i;
  let s = seed >>> 0;
  for (let i = 255; i > 0; i--) {
    s = (Math.imul(s, 1103515245) + 12345) >>> 0;
    const j = s % (i + 1);
    const tmp = p[i];
    p[i] = p[j];
    p[j] = tmp;
  }
  for (let i = 0; i < 256; i++) {
    PERM[i] = p[i];
    PERM[i + 256] = p[i];
    const angle = (p[i] / 256) * Math.PI * 2;
    GRAD[i] = Math.cos(angle);
    GRAD[i + 256] = Math.sin(angle);
  }
}

export function perlin2D(x: number, y: number): number {
  const xi = Math.floor(x) & 255;
  const yi = Math.floor(y) & 255;
  const xf = x - Math.floor(x);
  const yf = y - Math.floor(y);
  const u = xf * xf * xf * (xf * (xf * 6 - 15) + 10);
  const v = yf * yf * yf * (yf * (yf * 6 - 15) + 10);

  const aa = PERM[PERM[xi] + yi];
  const ab = PERM[PERM[xi] + yi + 1];
  const ba = PERM[PERM[xi + 1] + yi];
  const bb = PERM[PERM[xi + 1] + yi + 1];

  const g1 = GRAD[aa] * xf + GRAD[aa + 256] * yf;
  const g2 = GRAD[ba] * (xf - 1) + GRAD[ba + 256] * yf;
  const g3 = GRAD[ab] * xf + GRAD[ab + 256] * (yf - 1);
  const g4 = GRAD[bb] * (xf - 1) + GRAD[bb + 256] * (yf - 1);

  const x1 = g1 + u * (g2 - g1);
  const x2 = g3 + u * (g4 - g3);
  return x1 + v * (x2 - x1);
}

export function perlinStrip(
  steps: number,
  baseFreq: number,
  seed: number,
  offsetX: number,
  offsetY: number,
): Float32Array {
  perlinSeed(seed);
  const result = new Float32Array(steps);
  for (let i = 0; i < steps; i++) {
    const t = i / steps;
    const nx = t * baseFreq + offsetX;
    const ny = offsetY;
    result[i] = perlin2D(nx, ny);
  }
  return result;
}
